import './kitStyles';
import { useState } from 'react';

/**
 * WEB-3310 юнит 2а-1 — состояние в `localStorage`, эталон `useStored(key, def)`:
 * пусто или хранилище недоступно — значение по умолчанию; запись без хранилища
 * не падает (просто не помним).
 */
export function useStored(key: string, def: string): [string, (x: string) => void] {
  const [v, setV] = useState<string>(() => {
    try {
      return localStorage.getItem(key) || def;
    } catch {
      return def;
    }
  });
  return [
    v,
    (x: string) => {
      setV(x);
      try {
        localStorage.setItem(key, x);
      } catch {
        /* без хранилища — не помним */
      }
    },
  ];
}
